/**
 * 发布——三方视频链接校验
 */
import request, { MethodEnum } from '@/utils/fetch';

export enum CheckOutSideVideoStatus {
  success = 'success',
  fail = 'fail',
}

export type ICheckOutSideVideoReq = {
  url: string;
};

export type ICheckOutSideVideoRes = {
  description: string;
  img_big: string;
  img_default: string;
  img_large: string;
  status: CheckOutSideVideoStatus;
  title: string;
  url: string;
};

export const checkOutSideVideo = (
  params: ICheckOutSideVideoReq
): Promise<ICheckOutSideVideoRes> => {
  return request({
    url: '/common/utils/video/parse',
    method: MethodEnum.POST,
    params,
  }).then((data) => data?.item || {});
};
